// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1DDRw","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__xLGGU","gfeWrapper":"CalendarEvent_gfeWrapper__dTJVw"};